<!-- ************************************************************************************************************************************* -->
<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
    <span *ngIf="lang==1"> درج کاربر </span>
    <span *ngIf="lang==2"> --- </span>
    <span class="close" (click)="close()">
        <mat-icon>close</mat-icon>
    </span>
</div>

<form [formGroup]="form1" (ngSubmit)="insert()">
    <div mat-dialog-content class="matDialogContent">
        <div class="row">
            <div class='col-md-912 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <div class="row">

                    <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="sex" class='wh-label'>
                            <span *ngIf="lang == 1"> عنوان :</span>
                            <span *ngIf="lang == 2"> --- :</span>
                            <span (click)="reset_input(214)">
                                <mat-icon class="close" class="input_search input_search_pe"
                                    [ngClass]="{input_search_en:lang==2}">close
                                </mat-icon>
                            </span>
                            <input class='wh-input' formControlName='sex_title' autocomplete="off" [required]="true"
                                readonly (click)="load_services(214)">
                            <input class='wh-input' formControlName='sex' autocomplete="off" [required]="true" readonly
                                [hidden]="true">
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="title" class='wh-label'>
                            <span *ngIf="lang == 1">نام مشتری :</span>
                            <span *ngIf="lang == 2"> --- :</span>
                            <input class='wh-input' formControlName='title' autocomplete="off" required>
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="cellphone" class='wh-label'>
                            <span *ngIf="lang == 1"> شماره همراه :</span>
                            <span *ngIf="lang == 2"> cellPhone :</span>
                            <input class='wh-input' formControlName='cellphone' pattern="[0-9]{1,}" maxlength="11"
                                maxlength=11 autocomplete="off" required (keypress)="serverService.get_number($event)">
                        </label>
                    </div>
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="phone" class='wh-label'>
                            <span *ngIf="lang == 2">--- :</span>
                            <span *ngIf="lang == 1"> شماره ثابت :</span>
                            <input class='wh-input' formControlName='phone' autocomplete="off"
                                (keypress)="serverService.get_number($event)"
                                (keypress)="serverService.get_number($event)">
                        </label>
                    </div>
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="Email" class='wh-label'>
                            <span *ngIf="lang == 1"> پست الکترونیک :</span>
                            <span *ngIf="lang == 2">Email :</span>
                            <input class='wh-input' formControlName='email' autocomplete="off">
                        </label>
                    </div>
                    <div class='col-md-6 col-lg-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="address" class='wh-label'>
                            <span *ngIf="lang == 1"> آدرس :</span>
                            <span *ngIf="lang == 2">Address :</span>
                            <input class='wh-input' formControlName='address' autocomplete="off">
                        </label>
                    </div>
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="national_id" class='wh-label'>
                            <span *ngIf="lang == 1"> شناسه ملی:</span>
                            <span *ngIf="lang == 2">--- :</span>
                            <input class='wh-input' formControlName='national_id' maxlength="11"
                                (keypress)="serverService.get_number($event)" autocomplete="off">
                        </label>
                    </div>
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="economic_id" class='wh-label'>
                            <span *ngIf="lang == 1"> کد اقتصادی:</span>
                            <span *ngIf="lang == 2">--- :</span>
                            <input class='wh-input' formControlName='economic_id' maxlength="12"
                                (keypress)="serverService.get_number($event)" autocomplete="off">
                        </label>
                    </div>
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="post_code" class='wh-label'>
                            <span *ngIf="lang == 1"> کد پستی:</span>
                            <span *ngIf="lang == 2">--- :</span>
                            <input class='wh-input' formControlName='post_code'
                                (keypress)="serverService.get_number($event)" autocomplete="off" maxlength="10">
                        </label>
                    </div>
                    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                        style='margin-top:5px'>
                        <label for="comment" class='wh-label'>
                            <span *ngIf="lang == 2">Comment :</span>
                            <span *ngIf="lang == 1"> توضیحات :</span>
                            <textarea class="wh-input" formControlName='comment' style="height:80px"></textarea>
                        </label>
                    </div>
                </div><!-- row -->


            </div><!-- col-md-8 col-lg-8 col-sm-8 col-xs-12  -->
        </div><!-- row -->
    </div> <!-- content -->
    <div mat-dialog-actions align="start" class="pe1 matDialogActions" [ngClass]="{en1:lang==2}"
        style="padding-right:25px">
        <button class="btn_pe" [ngClass]="{btn_en:lang==2}" [disabled]="!form1.valid">
            <span *ngIf="lang==2">Save</span>
            <span *ngIf="lang==1">ذخیره</span>
        </button>
    </div><!-- row -->
</form>